"use client"
import clsx from "clsx";
import { memo } from "react";
import Cta from "@/components/cta/cta";
import Leaf from "@/components/icon/leaf";
import Underline from "@/components/svg/underline";
import useBatchCardAnimation from "@/hooks/useBatchCardAnimation";

function RecordCtaCard({ className = "", isParentInView, index = 0, intertia = 1, isFirstInBatch = false, batchIndex, onBatchEnter, isHidden, isSmall = false }) {
  const { rootRef, scrollRef } = useBatchCardAnimation({
    index,
    isParentInView,
    isFirstInBatch,
    batchIndex,
    onBatchEnter,
  });

  return (
    <div className={clsx(className, isHidden && 'invisible')} ref={scrollRef}>
      <div className="flex flex-col gap-y-(--space-5) opacity-[0.001] will-change-transform motion-reduce:opacity-100 motion-reduce:translate-y-0" ref={rootRef}>
        <div className={clsx('relative flex flex-col justify-center xl:aspect-305/422 items-start bg-main-dark px-(--space-7) py-(--space-9) md:py-(--space-7) md:px-[9.2%] md:px-[12.26%] lg:px-[10.26%] xl:px-(--space-7) xl:py-(--space-9) text-main-light', isSmall && 'max-lg:px-4.5 max-lg:py-6 mx-lg:body-2-small')}>
          <div className="absolute inset-0 bg-white/10" />
          <Leaf className={clsx('relative w-(--space-9) md:w-[15.33%] xl:w-(--space-8) h-auto text-main-green mb-(--space-8) md:mb-[11.88%] xl:mb-(--space-9)', isSmall && 'max-lg:hidden')} />
          <div className={clsx('md:hidden xl:block relative heading-3-small lg:heading-4-small xl:heading-4 mb-(--space-7) md:mb-[11.88%] xl:mb-9', isSmall && 'max-md:heading-5-small')}>
            {isSmall && (
              <>
                <div className="max-md:hidden">
                  <span className="relative block w-fit"><span>Curious about</span><Underline isActive={true} size="thin-medium" className="absolute left-0 -bottom-1 w-[90%]" /></span>
                  <span className="relative block w-fit"><span className="whitespace-nowrap">your own story?</span><Underline isActive={true} size="thin-large" className="absolute w-full left-0 -bottom-1" /></span>
                </div>

                <div className="md:hidden">
                  <span className="relative block w-fit"><span>Curious</span><Underline isActive={true} size="thin-medium" fullWidth className="block absolute left-0 -bottom-0 scale-y-[1.8]" /></span>
                  <span className="relative block w-fit"><span>about your</span><Underline isActive={true} size="thin-large" fullWidth className="block absolute left-0 -bottom-0 scale-y-[1.8]" /></span>
                  <span className="relative block w-fit"><span>own story?</span><Underline isActive={true} size="thin-large" fullWidth className="block absolute left-0 -bottom-0 scale-y-[1.8]" /></span>
                </div>
              </>
            )}

            {!isSmall && (
              <>
                <span className="relative block"><span>Curious about</span><Underline isActive={true} size="thin-medium" className="absolute left-0 -bottom-1 w-[90%]" /></span>
                <span className="relative block"><span className="whitespace-nowrap">your own story?</span><Underline isActive={true} size="thin-large" className="absolute w-full left-0 -bottom-1" /></span>
              </>
            )}
          </div>

          <div className="hidden md:block xl:hidden relative heading-5-medium md:heading-5-small lg:heading-4-small mb-(--space-7) md:mb-[11.88%]">
            <span className="relative block"><span>Curious</span><Underline isActive={true} size="thin-medium" className="absolute left-0 bottom-0 w-[90%] scale-y-[1.3]" /></span>
            <span className="relative block"><span>about your</span><Underline isActive={true} size="thin-medium" className="absolute left-0 bottom-0 w-[90%] scale-y-[1.3]" /></span>
            <span className="relative block"><span className="whitespace-nowrap">own story?</span><Underline isActive={true} size="thin-large" className="absolute w-full left-0 bottom-0 scale-y-[1.3]" /></span>
          </div>
          <p className={clsx('max-md:w-[90%] relative body-3 text-pretty md:body-2-extra-small xl:body-2 mb-(--space-8) md:mb-[11.88%] xl:mb-(--space-9)', isSmall && 'max-lg:text-[0.75rem]')}>
            Pieces of your history are here in records. Get started—there's so much to discover.
          </p>
          <Cta
            className={clsx('relative cta-big md:cta-small xl:cta', isSmall && 'max-md:cta-small')}
            href="http://ancestry.com/story-scout"
          >
            Try Ancestry now
          </Cta>
        </div>
      </div>
    </div>
  )
}

export default memo(RecordCtaCard);
